module.exports = __webpack_public_path__ + "static/media/sideBarFooltball.724705a5.svg";